import Chaplin from 'chaplin';
import ResponseSet from 'ef/models/evaluations/response_set';

const ResponseSetCollection = Chaplin.Collection.extend({
  model: ResponseSet,
  comparator: 'index',
});

export default ResponseSetCollection;
